import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import JobSelector from "./JobSelector";
import EligibleTable from "./EligibleTable";
import { getJobs, getEligibleStudents } from "../../../redux/features/careerSlice";

// Sidebar "Who Can Apply" page: latest job selected by default; change via the dropdown.
const CareerEligiblePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobData, eligibleStudents, loading } = useSelector((state) => state.career);
  const [job, setJob] = useState(null);
  const autoSelected = useRef(false);
  // whether the jobs call has come BACK, which is not the same as whether there
  // are any. Without this, a module with no jobs says "Loading jobs…" for ever.
  const [jobsLoaded, setJobsLoaded] = useState(false);

  useEffect(() => {
    dispatch(getJobs({ page: 1, limit: 100, filter: "" })).finally(() =>
      setJobsLoaded(true),
    );
  }, [dispatch]);

  // default-select the latest (first) job once jobs load
  useEffect(() => {
    const jobs = jobData?.data || [];
    if (!autoSelected.current && jobs.length) {
      autoSelected.current = true;
      setJob(jobs[0]);
      dispatch(getEligibleStudents(jobs[0].career_job_id));
    }
  }, [jobData, dispatch]);

  const onSelect = (j) => {
    setJob(j);
    if (j) dispatch(getEligibleStudents(j.career_job_id));
  };

  const jobs = jobData?.data || [];

  return (
    <GlobalWrapper title={"Who Can Apply"}>
      <JobSelector jobs={jobs} value={job} onChange={onSelect} />
      {job ? (
        <EligibleTable rows={eligibleStudents?.data || []} loading={loading} />
      ) : !jobsLoaded ? (
        <Typography color="text.secondary">Loading jobs…</Typography>
      ) : (
        // no job selected. Which of the two reasons it is matters: an empty
        // module needs a job posting, a full one just needs a pick.
        <Stack spacing={1.5} alignItems="flex-start" sx={{ mt: 2 }}>
          <Typography color="text.secondary">
            {jobs.length
              ? "Pick a job above to see who can apply."
              : "No jobs have been posted yet."}
          </Typography>
          {!jobs.length && (
            <Button variant="outlined" size="small" onClick={() => navigate("/career-connect/jobs")}>
              Go to Jobs
            </Button>
          )}
        </Stack>
      )}
    </GlobalWrapper>
  );
};

export default CareerEligiblePage;
